export type NewsCategory = '全部' | '公司公告' | '產品資訊' | '產業動態';

export interface NewsItem {
  id: string;
  category: Exclude<NewsCategory, '全部'>;
  date: string;
  title: string;
  excerpt: string;
  content: string;
  tags: string[];
}

export const newsCategories: NewsCategory[] = ['全部', '公司公告', '產品資訊', '產業動態'];

export const newsList: NewsItem[] = [
  {
    id: 'n001',
    category: '公司公告',
    date: '2024-11-15',
    title: '2024 年年終營業時間公告',
    excerpt: '敬告各位客戶，益維企業將於 2024 年 12 月 28 日（六）起至 2025 年 1 月 5 日（日）暫停辦公...',
    content: `敬告各位客戶：

益維企業將於 2024 年 12 月 28 日（六）起至 2025 年 1 月 5 日（日）暫停辦公，1 月 6 日（一）正式恢復上班。

放假期間如有緊急需求，請來信至 service@electronicsworld.com.tw，我們將於復工後盡速回覆。

感謝您一直以來對益維的支持與愛護，祝您新年快樂、萬事如意！

益維企業有限公司 敬啟`,
    tags: ['年假', '營業時間'],
  },
  {
    id: 'n002',
    category: '產品資訊',
    date: '2024-10-28',
    title: '全新 SS316L 防爆接線箱系列正式上市',
    excerpt: '益維企業推出全新 SS316L 系列防爆接線箱，通過 ATEX 與 IECEx 雙重認證，適用 Zone 1/Zone 2 危險區域，歡迎洽詢報價。',
    content: `益維企業正式推出全新 SS316L 防爆接線箱系列，此系列產品採用 316L 高等級不銹鋼材質，在防腐蝕性能上較 304 材質更為出色，特別適合海岸工廠、化工廠及食品加工業等對衛生及腐蝕要求嚴格的場所。

主要規格特色：
• 材質：SS316L 不銹鋼
• 防護等級：IP65 / IP66
• 防爆認證：ATEX / IECEx（Zone 1、Zone 2）
• 防爆類型：EExe 增安型
• 尺寸：多款尺寸可選（150×150 至 600×800mm）
• 表面處理：酸洗鈍化

如需詳細規格或報價，歡迎透過官網表單或致電業務部門洽詢。`,
    tags: ['SS316L', '防爆', 'ATEX', '新品上市'],
  },
  {
    id: 'n003',
    category: '產業動態',
    date: '2024-10-10',
    title: '2024 台灣石化工業展覽參展報告',
    excerpt: '益維企業於今年 10 月參與台灣石化工業展，展示最新防爆控制設備，與眾多業界夥伴交流，現場反應熱烈。',
    content: `益維企業於 2024 年 10 月 8 日至 10 日參加於台北南港展覽館舉辦的「2024 台灣石化工業展覽」，本次展出內容涵蓋最新的防爆接線箱、GRP 控制箱、防爆變壓器及 HMI 操作面板等系列產品。

展覽期間，益維攤位吸引了大量工程師、採購主管及廠商代表前來參觀，現場就防爆設備的選型、認證標準及安裝注意事項進行了深入交流。

我們也趁此機會與數家歐洲原廠代表進行了業務洽談，預計將於 2025 年第一季引進更多新品。感謝所有蒞臨本次展覽的客戶與夥伴，期待與您下次相見！`,
    tags: ['展覽', '石化工業', '南港展覽館'],
  },
  {
    id: 'n004',
    category: '產品資訊',
    date: '2024-09-05',
    title: 'GRP 防爆箱新款 IP67 等級產品正式到貨',
    excerpt: '全新 GRP 防爆接線箱 IP67 等級產品已到貨，較前代提升防水防塵規格，適合海岸及重工業戶外環境，歡迎索取樣品試用。',
    content: `為因應客戶對於更高防水等級的需求，益維企業正式引進 GRP IP67 防爆接線箱系列，此款產品在原有 IP65 基礎上升級，提供更完善的粉塵及液態水防護。

產品主要優勢：
• 材質：玻璃纖維強化聚酯（GRP），耐腐蝕、輕量
• 防護等級：IP67（可短暫浸水）
• 防爆認證：ATEX Zone 1 / Zone 2
• 顏色：標準灰色，可依需求客製
• 進線孔：預留多處進線孔，可加裝防爆電纜壓縮接頭

適用場域：沿海石化廠、造船廠、廢水處理廠等高濕度環境。

現貨有限，有興趣的客戶請儘早聯繫業務人員索取報價或樣品。`,
    tags: ['GRP', 'IP67', '防水', '新品到貨'],
  },
  {
    id: 'n005',
    category: '公司公告',
    date: '2024-08-20',
    title: '益維企業業務部門新增專線電話',
    excerpt: '為提升服務品質，益維企業業務部門自 2024 年 9 月 1 日起新增直撥專線，方便客戶快速聯繫業務代表。',
    content: `為提升客戶服務效率，益維企業業務部門自 2024 年 9 月 1 日起正式啟用業務直撥專線，客戶可依產品類別直接聯絡對應的業務代表，減少轉接等待時間。

新增聯絡方式：
• 工業箱體類產品業務：分機 101
• 變壓器類產品業務：分機 102
• 防爆設備類產品業務：分機 103
• 報價/議價專線：分機 110

原有總機號碼 +886-2-2651-6999 持續使用，歡迎繼續利用。如有任何問題，請隨時與我們聯繫。`,
    tags: ['公告', '業務專線', '聯絡資訊'],
  },
  {
    id: 'n006',
    category: '產業動態',
    date: '2024-07-18',
    title: 'ATEX 2024 最新法規更新摘要',
    excerpt: '歐盟 ATEX 指令 2014/34/EU 於 2024 年有若干技術細節修訂，益維企業整理重點摘要，協助客戶了解對採購及認證的影響。',
    content: `歐盟 ATEX 指令 2014/34/EU 係目前全球防爆設備最主要的認證依據之一，2024 年版本更新了以下幾項技術重點，對製造商與終端用戶均有一定影響：

主要更新重點：
1. 電氣防爆設備溫度等級標示方式調整，新增 T6A、T6B 細分等級
2. 防爆接線箱與控制箱的電纜進線孔密封要求更嚴格，需通過更完整的 IP 等級測試記錄
3. IECEx 與 ATEX 交叉認證流程部分簡化，有助於縮短產品認證時程
4. 增安型（EExe）設備對端子絕緣距離要求提高，廠商需更新測試報告

益維代理的所有防爆產品均已取得最新版本的認證文件，客戶如需取得最新認證副本或詳細技術資料，請聯繫我們的技術部門。`,
    tags: ['ATEX', '法規更新', 'IECEx', '防爆認證'],
  },
  {
    id: 'n007',
    category: '產品資訊',
    date: '2024-06-12',
    title: '防爆 HMI 操作面板（7 吋觸控）現貨供應',
    excerpt: '歐洲原廠最新款 7 吋防爆觸控 HMI 面板已進口到貨，符合 ATEX EExe Zone 2 規範，支援多種工業通訊協定，現貨數量有限。',
    content: `益維企業正式宣布，歐洲原廠最新款 7 吋防爆觸控 HMI 面板已完成進口通關，現貨供應中。

產品規格亮點：
• 螢幕：7 吋 TFT LCD，解析度 1024×600
• 防護等級：IP66
• 防爆認證：ATEX EExe Zone 2
• 通訊協定：Modbus RTU/TCP、PROFIBUS DP、EtherNet/IP
• 操作溫度：-20°C 至 +60°C
• 防爆外殼材質：鋁合金陽極處理

此款 HMI 適合用於 Zone 2 石化廠、電廠及工廠自動化系統的現場操作介面。現貨數量有限，歡迎儘早洽詢。`,
    tags: ['HMI', '防爆', '觸控面板', '現貨'],
  },
  {
    id: 'n008',
    category: '產業動態',
    date: '2024-05-30',
    title: '台灣石化業未來五年擴廠趨勢分析',
    excerpt: '根據工業局最新報告，台灣石化業者預計在未來五年投入超過 3,000 億台幣進行廠房升級，防爆設備市場前景看好。',
    content: `根據經濟部工業局發布的「2024 石化業中長期發展計畫」，台灣石化業者計畫在未來 5 年（2024–2028）投入約 3,000 億台幣，針對老舊廠區進行設備更新、安全升級及數位轉型。

對防爆設備市場的影響：
• 老舊控制箱體更換需求增加，尤其 SS316L 及 GRP 材質需求預計成長 20~30%
• 符合最新 ATEX/IECEx 認證的設備優先採用，舊認證設備面臨替換壓力
• 智慧型防爆 HMI 及遠端監控設備需求快速上升，預計年複合成長率逾 15%
• EPC 工程承包商在報價階段即開始指定品牌，益維代理品牌認知度持續提升

益維企業將持續引進符合最新規範的歐美防爆設備，協助台灣石化業者順利完成設備升級，提升工廠安全水準。`,
    tags: ['產業趨勢', '石化業', '市場分析'],
  },
  {
    id: 'n009',
    category: '公司公告',
    date: '2024-04-01',
    title: '益維企業官網全新改版上線',
    excerpt: '益維企業官方網站全面改版，新增線上詢問表單及完整產品目錄瀏覽功能，提升客戶使用體驗，歡迎瀏覽並給予意見。',
    content: `益維企業有限公司官方網站正式全面改版上線！

本次改版重點：
• 全新視覺設計，提升閱覽舒適度與品牌形象
• 完整的產品分類瀏覽系統，可依類別快速找到所需產品
• 線上詢問表單，方便客戶直接送出詢問或報價需求
• 行動裝置最佳化，完整支援手機及平板瀏覽

我們非常重視客戶的使用體驗，如您對新網站有任何建議或問題，歡迎透過聯絡我們頁面告知，我們將持續優化改進。感謝您的支持！`,
    tags: ['官網改版', '公告'],
  },
  {
    id: 'n010',
    category: '產品資訊',
    date: '2024-03-15',
    title: '不銹鋼落地型配電箱新規格上架',
    excerpt: '益維企業新增多款 SS304 落地型大尺寸配電箱，符合 IP54 等級，適用工廠配電室及電氣室，提供客製化尺寸服務。',
    content: `為滿足客戶對大尺寸配電箱的需求，益維企業新增多款 SS304 落地型配電箱規格，現已正式上架供應。

新品規格：
• 材質：SUS304 不銹鋼
• 防護等級：IP54
• 標準尺寸：600×800×2000mm、800×800×2000mm、1200×600×2000mm
• 門型：單門、雙門（附三點鎖）
• 內含：鍍鋅安裝板、接地端子
• 表面：2B 磨面 / 拋光鏡面（可選）

此外，我們亦提供完全客製化服務，客戶可指定尺寸、門開方向、進線孔位置及附件配置，適合各種工廠配電室及電氣控制室的專案需求。

詳細報價請洽業務部門。`,
    tags: ['SS304', '落地型', '配電箱', '客製化'],
  },
];
